import logo from './logo.svg';
import './App.css';
import Pexelsc from './components/Pexelsg/pexel';
function App() {
  return (
    <div className="App">
     <Pexelsc/>
    </div>
  );
}

export default App;
